module.exports = __webpack_public_path__ + "img/exclusive-offer.5ec42973.svg";